<div style="display: flex; align-items: center; justify-content: space-between; margin: 20px 0px 10px;">
  <h2 class="cpo-section-title" style="margin: 0px !important; padding: 0px !important;">Manage Account Brands</h2>
  @if (hasWriteAccess) { <button style="cursor: pointer; margin-top: 0px;" class="btn-core toolbar-button" (click)="create()">Add Brand</button> }
</div>

<div [showLoadingSpinner]="loading">
  <table class="cpo-selectable-table">
    <thead>
      <tr class="cpo-selectable-table__header-row">
        <th class="no-sort">Brand name</th>
        @if (hasWriteAccess) {
          <th class="no-sort">Actions</th>
        }
      </tr>
    </thead>
    @for (item of records; track item; let i = $index) {
      <tr id="tr_view_{{ i }}" class="cpo-selectable-table__row">
        <td>{{ item.name }} (Used by {{ item.count }} merchants)</td>
        @if (hasWriteAccess) {
          <td style="width: 20%;">
            <app-icon [style]="'cursor: pointer; margin-right: 30px;'" 
              [title]="'Edit brand name'" 
              color="var(--color-action-icon)" 
              (click)="select(item)" type="Edit">
            </app-icon>
            <app-icon [hidden]="item.count != 0" [style]="'cursor: pointer;'" title="Delete customer" [color]="'var(--color-action-icon-delete)'"
              (click)="btnDelete_click(item)" type="Trash"></app-icon>
          </td>
        }
      </tr>
    }
  </table>
</div>